/* istanbul ignore file */
export * from './SearchResultHeader';
